// extracted by mini-css-extract-plugin
export default {"copy":"copy__GTTCe","error":"error__g7MHZ","copy__label":"copy__label__WBdAJ","edit":"edit__t7oaE","edit__field":"edit__field__JrXuC"};